<button
  im-button
  [class]="currentAmount() | quotaStyle: alwaysShowNumber()"
  [class.default-cursor]="useDefaultCursor()"
  (click)="onClick()"
>
  <i
    iconStart
    [class]="'icon icon--' + (currentAmount() | quotaIcon: alwaysShowNumber())"
    aria-hidden="true"
  ></i>
  {{
    currentAmount()
      | quotaTranslation: positiveQuota() : emptyQuota() : negativeQuota()
      | translate
  }}
  {{ currentAmount() | quotaNumber: alwaysShowNumber() }}
</button>
